var _path, _path2, _path3, _path4, _path5, _g, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 359,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 359C0 160.719 80.443 0 179.5 0S359 160.719 359 359H0Z",
    fill: "#9B8579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.75 59.833c8.26 0 14.958-6.697 14.958-14.958s-6.697-14.959-14.959-14.959c-8.26 0-14.958 6.698-14.958 14.959s6.697 14.958 14.958 14.958ZM269.249 59.833c8.262 0 14.959-6.697 14.959-14.958s-6.697-14.959-14.959-14.959c-8.261 0-14.958 6.698-14.958 14.959s6.697 14.958 14.958 14.958Z",
    fill: "#9B8579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.145 74.792c4.131 0 7.479-6.697 7.479-14.959 0-8.26-3.348-14.958-7.479-14.958-4.13 0-7.479 6.697-7.479 14.958 0 8.262 3.349 14.959 7.479 14.959ZM231.854 74.792c4.131 0 7.479-6.697 7.479-14.959 0-8.26-3.348-14.958-7.479-14.958-4.13 0-7.479 6.697-7.479 14.958 0 8.262 3.349 14.959 7.479 14.959ZM179.999 61.828c-15.124 0-29.085 9.473-39.888 23.434a20.967 20.967 0 0 0 0 25.928c10.969 13.961 24.764 23.435 39.888 23.435 15.125 0 29.086-9.474 39.889-23.435a20.967 20.967 0 0 0 0-25.928c-10.803-13.96-24.764-23.434-39.889-23.434Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M119.666 89.75h-89.75M119.666 89.75l-89.75 14.958M329.084 89.75h-89.75M329.084 104.708l-89.75-14.958",
    stroke: "#584840",
    strokeWidth: 4.986,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M315.287 123.988C282.379 48.033 233.681 0 179.499 0 125.316 0 76.619 48.033 43.71 123.988c-22.936 53.185 14.626 113.683 72.465 115.345h3.49c5.984 0 11.967-.498 17.784-1.329 27.756-4.155 56.177-4.155 84.099 0 5.817.831 11.801 1.329 17.784 1.329h3.49c57.839-1.662 95.401-62.16 72.465-115.345Zm-135.788 70.47c-33.075 0-74.792-3.49-74.792-44.875 0-41.384 41.717-89.75 74.792-89.75 33.074 0 74.791 48.366 74.791 89.75 0 41.385-41.717 44.875-74.791 44.875Z",
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#584840",
    strokeWidth: 4.986,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.499 134.625v14.958M149.583 164.542l29.917-14.959M209.416 164.542l-29.917-14.959"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.458 166.958v-7.479L179.499 152l-14.958 7.479v7.479a7.449 7.449 0 0 0 7.479 7.48 7.449 7.449 0 0 0 7.479-7.48 7.449 7.449 0 0 0 7.479 7.48 7.449 7.449 0 0 0 7.48-7.48Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHog);
export default __webpack_public_path__ + "static/media/hog.351f702551fdcb7d45aaee81ef4f1ded.svg";
export { ForwardRef as ReactComponent };